import { componentStylesToCss } from '../componentStylesUtils';

const stylesAnyInputBase = (componentStyles) => `
  .jme-inputBase-wrapper {
    border: none;
    ${componentStylesToCss(componentStyles?.wrapper)}
  }
`;

export default stylesAnyInputBase;
